import React from 'react';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  hasDivider?: boolean;
  glowPosition?: 'left' | 'right' | 'center' | 'none';
}
export function SectionWrapper({
  children,
  className = '',
  id,
  hasDivider = false,
  glowPosition = 'none'
}: SectionWrapperProps) {
  return <section id={id} className={`relative py-24 md:py-32 ${className}`} data-id="element-211">
      {hasDivider && <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent" data-id="element-212" />}

      {/* Background Glows */}
      {glowPosition === 'left' && <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-900/10 blur-[120px] rounded-full pointer-events-none" data-id="element-213" />}
      {glowPosition === 'right' && <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[600px] h-[600px] bg-teal-900/10 blur-[120px] rounded-full pointer-events-none" data-id="element-214" />}
      {glowPosition === 'center' && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/10 blur-[150px] rounded-full pointer-events-none" data-id="element-215" />}

      <div className="relative z-10 max-w-7xl mx-auto px-6" data-id="element-216">{children}</div>
    </section>;
}